import { render } from "./LogIn.vue?vue&type=template&id=2f462114&scoped=true"
import script from "./LogIn.vue?vue&type=script&lang=js"
export * from "./LogIn.vue?vue&type=script&lang=js"

import "./LogIn.vue?vue&type=style&index=0&id=2f462114&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f462114"]])

export default __exports__